import { defineStore, storeToRefs } from 'pinia'
import { useClientStore } from '@/stores/ClientStore'
import { useAuthenticationStore } from '@/stores/AuthenticationStore'
import { get as _get } from 'lodash'
import available from '@/vendors/i18n/translations/available'
import i18n from '@/vendors/i18n'
import axios from 'axios'

export const useLanguageStore = () => {
  const { authUser } = storeToRefs(useAuthenticationStore())
  const { getClient } = useClientStore()
  const { client } = getClient()

  const innerStore = defineStore('LanguageStore', {
    state: () => ({
      available_languages: Object.keys(available) || [],
      client_languages: _get(client.value, 'active_languages', []),
      locale: null
    }),
    getters: {
      languages: state => state.client_languages.reduce((acc, key) => available[key] ? [...acc, available[key]] : acc, []),
      getBrowserLocale: state => state.getIfAvailable(navigator.userLanguage || (navigator.languages && navigator.languages.length && navigator.languages[0]) || navigator.language || navigator.browserLanguage || navigator.systemLanguage),
      getLocaleStorage: state => state.getIfAvailable(localStorage.locale),
      getLocaleFromUrl: state => state.getIfAvailable(window.location.pathname.split('/')[1]),
      getLocaleFromUser: state => state.getIfAvailable(_get(authUser.value, 'language', null)),
      getDocumentLanguage: state => state.locale.split('-')[0],
      getDefaultLocale: state => state.client_languages[0]
    },
    actions: {
      setLocale (locale = null) {
        this.locale = i18n.locale = localStorage.locale = this.getIfAvailable(locale) || this.getLocaleFromUser || this.getLocaleFromUrl || this.getLocaleStorage || this.getBrowserLocale || this.getDefaultLocale
        document.querySelector('html').setAttribute('lang', this.getDocumentLanguage)
        axios.defaults.headers.common['Accept-Language'] = this.getDocumentLanguage
      },
      getIfAvailable (locale) {
        return locale && this.client_languages.includes(locale) ? locale : null
      },
      getLanguage (locale) {
        return this.languages.find(({ id }) => id === (locale || this.locale))
      }
    }
  })

  const store = innerStore()

  if (!store.locale) store.setLocale()

  return store
}